// AD&D 1st Edition experience point thresholds (minimum XP to reach a given
// level), by class. Index 0 is level 1 (always 0 XP). Sourced from the
// Player's Handbook (Unearthed Arcana for Barbarian).
//
// Bard is a special case: a character must reach 5th level Fighter, then
// 6th-8th level Thief, before Bard training (and this table) begins — that
// prerequisite climb isn't modeled here, only the Bard track itself.
const XP_TABLE = {
  Fighter: [0, 2001, 4001, 8001, 18001, 35001, 70001, 125001, 250001, 500001, 750001, 1000001],
  Paladin: [0, 2751, 5501, 12001, 24001, 45001, 95001, 175001, 350001, 700001, 1050001, 1400001, 1750001],
  Ranger: [0, 2251, 4501, 10001, 20001, 40001, 90001, 150001, 225001, 325001],
  Barbarian: [0, 6001, 12001, 24001, 48001, 80001, 150001, 275001, 500001, 1000001, 1500001],
  Cleric: [0, 1501, 3001, 6001, 13001, 27501, 55001, 110001, 225001, 450001, 675001, 900001, 1125001],
  Druid: [0, 2001, 4001, 7501, 12501, 20001, 35001, 60001, 90001, 125001, 200001, 300001, 750001, 1500001],
  'Magic-User': [0, 2501, 5001, 10001, 22501, 40001, 60001, 90001, 135001, 250001, 375001, 750001],
  Illusionist: [0, 2251, 4501, 9001, 18001, 35001, 60001, 95001, 145001, 220001, 440001, 660001],
  Thief: [0, 1251, 2501, 5001, 10001, 20001, 42501, 70001, 100001, 160001, 220001, 440001],
  Assassin: [0, 1501, 3001, 6001, 12001, 25001, 50001, 100001, 200001, 300001, 425001, 575001, 750001, 1000001, 1500001],
  Monk: [0, 2251, 4751, 10001, 22501, 47501, 98001, 200001, 350001, 500001, 700001, 950001, 1250001, 1750001, 2250001, 2750001, 3250001],
  Bard: [0, 2001, 4001, 8001, 16001, 25001, 40001, 60001, 85001, 110001, 150001, 200001, 400001]
};

const normalizeClassName = (value) => String(value || '').trim();

// Beyond a class's known table, extrapolate using that class's own last
// known per-level increment rather than guessing a shared rate.
export const getMinXpForLevel = (className, level) => {
  const table = XP_TABLE[normalizeClassName(className)];
  const lvl = Math.round(Number(level));
  if (!table || !Number.isFinite(lvl) || lvl < 1) return 0;

  if (lvl <= table.length) return table[lvl - 1];

  const lastIndex = table.length - 1;
  const step = table[lastIndex] - table[lastIndex - 1];
  return table[lastIndex] + step * (lvl - table.length);
};

export const XP_TABLE_CLASSES = Object.keys(XP_TABLE);
